import { useMutation, useQueryClient } from '@tanstack/react-query';
import { editSync, GPanelContactsKeys } from '../../gpanel-contacts-api';
import { LabelSync } from '../../shared/types';
import { useSyncByIdQuery } from '../../gpanel-contacts-queries';
import { useParams } from 'react-router-dom';
import GpanelContactsSyncForm from './gpanel-contacts-sync-form.tsx';
import GpanelContactsSyncFormSkeleton from './gpanel-contacts-sync-form-skeleton.tsx';

export default function GpanelContactsEditSync() {
  const syncId = useParams().syncId!;
  const { data: sync, isLoading } = useSyncByIdQuery(syncId);

  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({
      sync,
      changeLogMessage,
    }: {
      sync: Partial<LabelSync>;
      changeLogMessage?: string;
    }) => editSync(sync, changeLogMessage),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GPanelContactsKeys.AllSyncs],
      });
      queryClient.invalidateQueries({
        queryKey: [GPanelContactsKeys.LabelGroups],
      });
      queryClient.invalidateQueries({
        queryKey: [GPanelContactsKeys.LabelSyncs, String(sync?.labelId)],
      });
      queryClient.invalidateQueries({
        queryKey: [GPanelContactsKeys.GPanelLabels, String(sync?.labelId)],
      });
    },
  });

  return sync && !isLoading ? (
    <GpanelContactsSyncForm
      title={`Edit Contact Sync: ${sync.name}`}
      submitText="Update Sync"
      sync={sync}
      mutation={mutation}
    />
  ) : (
    <GpanelContactsSyncFormSkeleton />
  );
}
